<template>
  <div class="inputs" ref="inputs" v-express>
    <el-cascader
      :props="props"
      v-if="inputWriteable"
      v-validate="inputValidate"
      :name="inputName"
      :validate="validate"
      :placeholder="placeholder ? placeholder : '请选择'"
      v-model="inputVal"
      :ref="this.atter"
      clearable
    ></el-cascader>
    <eco-field-tail
      :fieldName="inputName"
      :readonly="!inputWriteable"
      :inputValue="inputVal"
    ></eco-field-tail>
    <span style="display:none;" v-validate>
      <slot name="labeldesc">{{ inputName }}</slot>
    </span>
  </div>
</template>

<script>
import utils from "@/utils.js";

export default {
  name: "eip-cascader",
  props: [
    "validate",
    "value",
    "name",
    "permission",
    "atter",
    "inputType",
    "placeholder",
    "ganged"
  ],
  data() {
    let _this = this;
    return {
      config: null,
      props: {
        value: _this.ganged.valueBind,
        label: _this.ganged.labelBind,
        lazy: true,
        lazyLoad(node, resolve) {
          const _promise = _this.search(node);
          _promise.then(function(nodes) {
            resolve(nodes);
          });
        }
      },
      newValidate: null
    };
  },
  computed: {
    inputVal: {
      get() {
        if (this.value) {
          if (this.value.constructor == String) {
            if (!this.value) {
              return "";
            }
            let cascaderModel = JSON.parse(this.value);
            if (!this.inputWriteable) {
              return cascaderModel.pathLabels.join("/");
            }

            return cascaderModel.path;
          }
          return this.value.path;
        } else {
          return this.value;
        }
      },
      set(val) {
        let selectValArr = this.$refs[this.atter].getCheckedNodes(false);
        if (selectValArr.length == 0) return;
        let result = {
          path: selectValArr[0].path,
          pathLabels: selectValArr[0].pathLabels
        };
        this.$emit("input", JSON.stringify(result));
      }
    },
    inputWriteable: function() {
      return utils.getWriteable(this.permission);
    },
    inputValidate: function() {
      if (this.newValidate) {
        return this.newValidate;
      }
      var validateObj = this.$store.state.index.validate;
      return utils.addRequiredOrNot(
        this.permission,
        this.validate,
        validateObj,
        this
      );
    },
    inputName: function() {
      let labeldesc = "";
      if (
        this.$slots &&
        this.$slots.labeldesc &&
        this.$slots.labeldesc[0].children &&
        this.$slots.labeldesc[0].children[0].text
      ) {
        labeldesc = this.$slots.labeldesc[0].children[0].text;
        return this.name ? this.name : utils.getName() + "-" + labeldesc;
      } else {
        return this.name ? this.name : utils.getName();
      }
    }
  },
  created() {
    // this.$validator = this.$root.$validator;
  },
  methods: {
    async search(node) {
      if (!this.config) {
        const res = await this.$store.dispatch(
          "form/getByAliasCq",
          this.ganged.alias
        );
        this.config = res;
        this.restfulUlr = this.config.url;
      }
      var str = this.config;
      var ganged = this.ganged;
      if (node) {
        let param = "";
        if (node && node.data) {
          param = node.data[this.ganged.valueBind];
        }
        if (str.dsType == "dataSource") {
          let Base64 = require("js-base64").Base64;
          if (JSON.stringify(ganged.bind) === "{}") {
            str.queryData = Base64.encode(
              JSON.stringify([{ key: ganged.valueBind, value: param }])
            );
          } else {
            var queryData = [];
            for (var key in ganged.bind) {
              queryData.push({ key: key, value: param });
            }
            str.queryData = Base64.encode(JSON.stringify(queryData));
          }
        } else {
          var conditionfield = JSON.parse(str.conditionfield);
          var params = {};
          conditionfield.forEach(ele => {
            params[ele.field] = "";
            if (node && node.data) {
              params[ele.field] = node.data[ganged.bind[ele.field]];
            }
          });
          str.url = this.restfulUlr + utils.queryParams(params, true);
        }
      } else {
        str.queryData = "";
      }

      const queryRes = await this.$store.dispatch("form/selectQuery", str);
      return queryRes.rows;
    }
  }
};
</script>

<style scoped>
div[aria-invalid="true"] >>> .el-input__inner,
div[aria-invalid="true"] >>> .el-input__inner:focus {
  border-color: #f56c6c;
}
>>> .el-autocomplete {
  display: block;
}
</style>
